import { Button, Select, Text, createListCollection } from "@chakra-ui/react"
import Pathicon from "@pathwright/ux/src/components/pathicon/Pathicon"

const renderOption = (node) => node

const ShareDropdown = ({ name, value, label, options, onChange }) => {
  const selectOptions = createListCollection({ items: options })

  const handleChange = (details) => {
    // Value contains an array of the option.value values.
    onChange(details.value?.[0])
  }

  return (
    <Select.Root
      name={name}
      positioning={{ placement: "bottom-end" }}
      collection={selectOptions}
      value={value}
      onValueChange={handleChange}
      w="unset"
      flexShrink={0}
    >
      <Select.Control>
        <Select.Trigger asChild>
          <Button
            size="sm"
            colorPalette="gray"
            variant="ghost"
            border="none"
            borderRadius="full"
          >
            <Select.ValueText placeholder={label} />
            <Select.IndicatorGroup pos="static" p={0}>
              <Select.Indicator>
                <Pathicon icon="chevron-down" />
              </Select.Indicator>
            </Select.IndicatorGroup>
          </Button>
        </Select.Trigger>
      </Select.Control>
      <Select.Positioner>
        <Select.Content
          border="solid 1px"
          borderColor="gray.100"
          borderRadius="4px"
          outline="none"
          boxShadow="none"
          overflow="hidden"
          p={0}
          minW={0}
        >
          {selectOptions.items.map((item) => (
            <Select.Item
              key={item.value}
              item={item}
              border="none"
              px={4}
              py={2}
            >
              {(item.render || renderOption)(<Text m={0}>{item.label}</Text>)}
              <Select.ItemIndicator>
                <Pathicon icon="check" />
              </Select.ItemIndicator>
            </Select.Item>
          ))}
        </Select.Content>
      </Select.Positioner>
    </Select.Root>
  )
}

export default ShareDropdown
